<span
  class="tp-icon-wrapper"
  [inlineSVG]="iconsPath + name + '.svg'"
  [class.responsive-icon]="isResponsive"
></span>
